import { LightningBoltIcon } from "@heroicons/react/solid";
import * as React from "react";
import type { CSS } from "~/config/stitches";
import { styled } from "~/config/stitches";
import { Icon } from "../../Icon";
import type { IconProps } from "../../Icon/Icon";
import type { FolderIconProps } from "../FolderIcon";
import { folderSizeToIconSize } from "../FolderIconConstant";

const FolderIconAutomatedWrapper = styled("div", {
  backgroundColor: "$white",
  borderRadius: "50% 50% 0 0",
  bottom: 0,
  left: 0,
  position: "absolute",
});

type FolderIconAutomatedProps = Pick<FolderIconProps, "size"> & {
  css?: CSS;
  color: IconProps["color"];
};

const FolderIconAutomated = (props: FolderIconAutomatedProps) => {
  return (
    <FolderIconAutomatedWrapper>
      <Icon
        label={`lock`}
        size={folderSizeToIconSize.get(props.size)}
        color={props.color}
        css={props.css}
      >
        <LightningBoltIcon />
      </Icon>
    </FolderIconAutomatedWrapper>
  );
};

export { FolderIconAutomated };
